import type { RoleConfig } from '../types.js';

export const goon: RoleConfig = {
  id: 'goon',
  faction: 'mafia',
  title: { ru: 'Громила', uk: 'Громило' },
  latin: 'GOON',
  number: '20',
  accent: '#c93a4a',
  ability: {
    ru: 'Простой солдат мафии. Ночью голосует за жертву вместе с командой.',
    uk: 'Простий солдат мафії. Вночі голосує за жертву разом з командою.',
  },
  abilities: [
    { key: 'kill', phase: 'night', cadence: 'every-night', canSelfTarget: false, killGroup: 'mafia' },
  ],
  reveals: { factions: ['mafia'] },
  victory: { type: 'mafia' },
};
